<div class="errorpage">
    <div class="row">
        <div class="col-md-12">
            <div class="errorInfo">
                <h1>201</h1>
                <div class="pageError">{{'labels.your_token' | translate}}</div>
            </div>
        </div>
    </div>
</div>